import { createStylesParams } from '@wix/tpa-settings';

export type IStylesParams = {};

export default createStylesParams<IStylesParams>({});
